module.exports = __webpack_public_path__ + "img/touzishouyi.7b6b3e72.png";